import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './languages';

import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enSettings from './locales/en/settings.json';
import enAuth from './locales/en/auth.json';
import enMovements from './locales/en/movements.json';
import enFilters from './locales/en/filters.json';
import enDashboard from './locales/en/dashboard.json';
import enAccounts from './locales/en/accounts.json';
import enCategories from './locales/en/categories.json';
import enTags from './locales/en/tags.json';
import enSourceFiles from './locales/en/sourceFiles.json';
import enChat from './locales/en/chat.json';
import enCurrencies from './locales/en/currencies.json';
import enDates from './locales/en/dates.json';
import enWorkspaces from './locales/en/workspaces.json';
import enOnboarding from './locales/en/onboarding.json';
import enGoals from './locales/en/goals.json';
import enRepairs from './locales/en/repairs.json';
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esSettings from './locales/es/settings.json';
import esAuth from './locales/es/auth.json';
import esMovements from './locales/es/movements.json';
import esFilters from './locales/es/filters.json';
import esDashboard from './locales/es/dashboard.json';
import esAccounts from './locales/es/accounts.json';
import esCategories from './locales/es/categories.json';
import esTags from './locales/es/tags.json';
import esSourceFiles from './locales/es/sourceFiles.json';
import esChat from './locales/es/chat.json';
import esCurrencies from './locales/es/currencies.json';
import esDates from './locales/es/dates.json';
import esWorkspaces from './locales/es/workspaces.json';
import esOnboarding from './locales/es/onboarding.json';
import esGoals from './locales/es/goals.json';
import esRepairs from './locales/es/repairs.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    settings: enSettings,
    auth: enAuth,
    movements: enMovements,
    filters: enFilters,
    dashboard: enDashboard,
    accounts: enAccounts,
    categories: enCategories,
    tags: enTags,
    sourceFiles: enSourceFiles,
    chat: enChat,
    currencies: enCurrencies,
    dates: enDates,
    workspaces: enWorkspaces,
    onboarding: enOnboarding,
    goals: enGoals,
    repairs: enRepairs,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    settings: esSettings,
    auth: esAuth,
    movements: esMovements,
    filters: esFilters,
    dashboard: esDashboard,
    accounts: esAccounts,
    categories: esCategories,
    tags: esTags,
    sourceFiles: esSourceFiles,
    chat: esChat,
    currencies: esCurrencies,
    dates: esDates,
    workspaces: esWorkspaces,
    onboarding: esOnboarding,
    goals: esGoals,
    repairs: esRepairs,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    ns: ['common', 'navigation', 'settings', 'auth', 'movements', 'filters', 'dashboard', 'accounts', 'categories', 'tags', 'sourceFiles', 'chat', 'currencies', 'dates', 'workspaces', 'onboarding', 'goals', 'repairs'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] Missing key: ${ns}:${key} (lang=${lng})`);
      }
    },
  });

export default i18n;
